import DarkFrameworkImages from '@vfgroup-oneplatform/framework/Themes/Modes/Dark/Images'

import images from '../../Images'

const Images = {
  ...DarkFrameworkImages,
  ic_bundle: images.ic_bundles_white,
  internet: images.internet_white,
  upload: images.upload_white,
  document: images.document_white,
  wifi: images.wifi_white,
  idIcon: images.idIcon_white,
  tv: images.tvWhite,
  close: images.close_white,
  deliveryAddress: images.deliveryAddressWhite,
  tv_bundle: images.tv_hi_mid_white,
}

export default Images